export default "__VITE_ASSET__BBL0Mb$n__"